<template>
  <v-container
    id="extended-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="fas fa-user-tie"
      icon-small
      color="primary"
      :title="$t('pageTitles.Elus/ElusList')"
    >
      <template #subtitle>
        <div class="text-right text-h3">
          <app-btn
            color="success"
            class="px-2 ml-1"
            elevation="0"
            min-width="0"
            small
            to="/elus/new"
          >
            <v-icon
              small
              v-text="'fas fa-plus'"
            />
          </app-btn>
        </div>
      </template>

      <v-simple-table class="mt-4">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t('forms.last_name') }}</th>
            <th>{{ $t('forms.first_name') }}</th>
            <th>{{ $t('forms.position') }}</th>
            <th>{{ $t('forms.picture') }}</th>
            <th class="text-right">
              {{ $t('forms.actions') }}
            </th>
          </tr>
        </thead>
        <tbody v-if="!elus || !elus.length">
          <tr>
            <td colspan="3">
              <i
                v-if="processing"
                class="fas fa-spin fa-spinner"
              ></i>
              <template v-else>
                {{ $t('forms.nodata') }}
              </template>
            </td>
          </tr>
        </tbody>

        <draggable
          v-else
          v-model="elus"
          tag="tbody"
          handle=".fa-arrows-alt"
          @change="sortHandler"
        >
          <tr
            v-for="elu in elus"
            :key="`elu-list-${elu.id}`"
          >
            <td>
              <i class="fas fa-arrows-alt"></i>
            </td>
            <td>{{ elu.last_name }}</td>
            <td>{{ elu.first_name }}</td>
            <td>{{ elu.position }}</td>
            <td>
              <img
                :src="elu.picture && (elu.picture.formats && elu.picture.formats.thumb_webp || elu.picture.url)"
                :alt="elu.full_name"
                :title="elu.full_name"
                class="elu-preview"
              />
            </td>
            <td class="text-right table-actions">
              <v-btn
                color="success"
                class="px-2 ml-2"
                elevation="0"
                min-width="0"
                small
                :to="`/elus/${elu.id}`"
              >
                <v-icon
                  small
                  v-text="'far fa-edit'"
                />
              </v-btn>
              <app-btn
                color="error"
                class="px-2 ml-2"
                elevation="0"
                min-width="0"
                small
                @click="initiateEluDelete(elu)"
              >
                <v-icon
                  small
                  v-text="'fas fa-trash'"
                />
              </app-btn>
            </td>
          </tr>
        </draggable>
      </v-simple-table>
    </material-card>
    <v-dialog
      v-model="showDeletionDialog"
      width="300"
    >
      <v-card>
        <v-card-text class="pt-4">
          {{ $t('delete_confirm') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="gray"
            text
            @click="closeDeletionDialog"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="deleteElu"
          >
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import serverError from '../../mixins/serverError';
export default {
  name: 'ElusList',

  mixins: [serverError],

  data: () => ({
    elus: [],
    showDeletionDialog: false,
    eluToDelete: null,
  }),

  computed: {
    ...mapGetters({
      allElus: 'elu/getElus',
      processing: 'global/getProcessing',
    }),
  },

  created() {
    this.$store.commit('elu/setElu', null);
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.elus = [];
      this.$store.dispatch('elu/fetchElus')
        .then(() => {
          this.elus = [...this.allElus];
        });
    },
    sortHandler() {
      const order = this.elus.map(category => category.id);
      const payload = { order };
      this.$store.dispatch('elu/reorderElus', payload)
        .then(response => {
          this.elus = response.data.data;
        })
        .catch(() => this.$toasted.error(this.$t('error_happened')));
    },
    initiateEluDelete(elu) {
      this.eluToDelete = elu.id;
      this.showDeletionDialog = true;
    },
    closeDeletionDialog() {
      this.eluToDelete = null;
      this.showDeletionDialog = false;
    },
    deleteElu() {
      this.$store.dispatch('elu/deleteElu', this.eluToDelete)
        .then(() => {
          this.$toasted.success(this.$t('item_deleted'));
          this.refreshData();
        })
        .catch(error => this.displayErrors(error))
        .finally(() => this.closeDeletionDialog());
    },
  },
}
</script>

<style lang="scss">
.fa-arrows-alt {
  cursor: grab;
}

.elu-preview {
  max-height: 40px;
}
</style>
